import type { FaireProductEntity } from "../../entity_types/product";

export const p_wu4a226rpj: FaireProductEntity = {
  token: "p_wu4a226rpj",
  type: "product",
  name: "Green Belly Hot Sauce",
  brandToken: "b_18u4q5xcev",
  brandName: "Green Belly Foods",
  imageUrl:
    "https://cdn.faire.com/fastly/f6860566c904f22b29cf8556ff8689536337f7de3281da1b6deb7c75fc823fa5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1e5d870d18bf4e7fa1c1fcda66a3ba2808ee4253ed3f96cd46bf0477e8334ad5.jpeg",
    "https://cdn.faire.com/fastly/251cba5bc64feaf6d462df6db6d64a5edd8fd4d6f8b5063885ac43b771a01693.jpeg",
    "https://cdn.faire.com/fastly/4587d8401be34bbfd4159c1597ba3d87e855a534ead57f3ebcb8c219ff890d88.jpeg",
  ],
  priceDollars: 4.99,
  description:
    "Green Belly Hot Sauce is inspired by Juan’s mother’s traditional Guatemalan cilantro-based hot sauce. Unlike most green sauces that use a tomatillo base, Green Belly uses fresh cilantro, garlic and olive oil to give this sauce a savory herbaceous flavor. Fiery habaneros and apple cider vinegar finish this off with a tasty zing!\n\n• Please make total order is in sets of 3 cases of 12 bottles, they can be mixed.\n• Orders are shipped in boxes of 3 cases (36 bottles)",
  tags: [],
  msrpDollars: 9.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:12.491Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
